import { CONTACT_EMAIL } from '../lib/links';

export interface FinalCTAProps {
  onBook: () => void;
}

export function FinalCTA({ onBook }: FinalCTAProps) {
  return (
    <section className="container section">
      <div className="cta-frame">
        <h2>
          Bring a part you&rsquo;ve been{' '}
          <em>putting off.</em>
        </h2>
        <p>
          Thirty minutes. We&rsquo;ll model it live, hand you the STEP, and
          you&rsquo;ll know within ten whether LMcad belongs in your bench.
        </p>
        <div className="actions">
          <button type="button" className="cta cta-primary" onClick={onBook}>
            Book a demo
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M2 7 H12 M8 3 L12 7 L8 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <a
            className="cta cta-ghost"
            href={`mailto:${CONTACT_EMAIL}?subject=LMcad%20question`}
          >
            Email us instead
          </a>
        </div>
      </div>
    </section>
  );
}
